import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import AudioList from './AudioList';
import TabContainer from './ui/TabContainer';
import MediaList from './ui/MediaList';
import TextDisplay from './ui/TextDisplay';
import ImageDisplay from './ui/ImageDisplay';
import Breadcrumb from './ui/Breadcrumb';
import BookmarkButton from './ui/BookmarkButton';
import LinkedItems from './ui/LinkedItems';
import MeterDisplay from './ui/MeterDisplay';
import _ from 'underscore';
import {Helmet} from 'react-helmet';

import config from './../config';
import helpers from './../lib/helpers';
import StanzaMetadataTable from './ui/StanzaMetadataTable';

function StanzaView(props) {
	const [data, setData] = useState(null);
	const [hideAudioList, setHideAudioList] = useState(false);
	const history = useHistory();

	useEffect(() => {
		if (props.match.params.id) {
			setHideAudioList(false);

			helpers.fetch(config.apiRoot+'/api/stanza/'+props.match.params.id, (json) => {
				if (!helpers.isNumber(props.match.params.id) && json.id) {
					history.replace(helpers.routerUrls['erindi']+json.id);

					return;
				}

				if (json.poem && json.poem.id && props.location.hash != '#syna_erindi') {
					history.replace(helpers.routerUrls['kvaedi']+json.poem.id);

					return;
				}

				setData(json);
			}, null, 'first_line');
		}
	}, [props.match.params.id]);

	const bragiCollections = {
		'hun': 'hunafloi',
		'arn': 'arnes',
		'har': 'haraldur',
		'mos': 'mos',
		'bor': 'borg',
		'kop': 'kop',
		'ska': 'skag'
	}

	const bragiTypes = {
		'laus': 'visur.php?VID=',
		'ljod': 'ljod.php?ID='
	}

	let otherFiles = data && data.files ? _.reject(data.files, (item) => item.extension == 'jpg') : [];

	const showPageInfo = (page) => {
		let info = [];

		if (page.volume) {
			info.push(page.volume);
		}

		if (page.page_number) {
			info.push(page.page_number);
		}

		if (page.page_name && page.page_name != page.page_number) {
			info.push(page.page_name);
		}

		return info.length > 0 ? ', '+info.join(', ') : '';
	}

	return (

			data &&
			<div className="content-container">

				<Breadcrumb currentElTitle={data.name || data.first_line} />

				<Helmet>
					<meta property="og:type"
						content="article"
					/>
					<meta property="og:title"
						content={'Ísmús | '+(data.name || data.first_line)}
					/>
					{
						data.contents && 
						<meta property="og:description"
							content={helpers.trim(data.contents, data.contents.length)}
						/>
					}
					<meta property="og:image" content='//ismus.is/img/share-image.png' />
				</Helmet>

				<div>
					<BookmarkButton id={data.id} title={data.name || data.first_line} type="stanza" className="float-right" />
					<h2>{data.name || data.first_line}</h2>
				</div>

				<div className="row mt-4">

					<div className="col-12 col-md-6">
						{
							data.contents && <div className="card gray-card mb-4">
								<div className="card-body">
									<TextDisplay className="poem text-larger" maxLength={2000} text={helpers.formatStanzaText(data.contents)} />
								</div>
							</div>
						}

						{
							data.info && data.info != '' && <div className="mb-4">
								<h4>Athugasemdir</h4>
								<TextDisplay text={data.info} />
							</div>
						}

						{
							data.note && data.note != '' && <div className="mb-4">
								<h4>Skýringar</h4>
								<TextDisplay text={data.note} />
							</div>
						}


					</div>

					<div className="col-12 col-md-6">

						<StanzaMetadataTable data={data} />

					</div>

				</div>

				<TabContainer useRouter={'true'} selectedTab={props.match.params.tab} baseUrl={helpers.routerUrls['erindi']+props.match.params.id}>

					<AudioList className="mt-4"
						erindi={data.id}
						disablePlayButtonRouteChange={true}
						tabname="hljodrit"
						tabtitle="Hljóðrit"
						hideAsTab={hideAudioList}
						searchParams={props.searchParams}
						onResponse={(data) => {
							setHideAudioList(data.length == 0);
					}}
					>
						<p className="mb-3"><small>Hljóðrit sem innihalda þetta erindi.</small></p>
					</AudioList>

					{
						data.folklore && data.folklore.length > 0 &&
						<div tabtitle="Sagnir/ævintýri" tabname="sagnir">
							<p class="mb-3"><small>Kemur fram í eftirfarandi sögnum/ævintýrum.</small></p>
							<table className="table">
								<thead>
									<tr>
										<th width="30%">Heiti</th>
										<th>Heimild</th>
									</tr>
								</thead>
								<tbody>
									{
										data.folklore.map((item, index) => <tr key={index}>
											<td>
												<Link to={helpers.routerUrls['folklore']+item.id}>{item.name}</Link>
											</td>
											<td>{item.source}</td>
										</tr>)
									}
								</tbody>

							</table>
						</div>
					}

					{
						data.pages && data.pages.length > 0 &&
						<div tabtitle={'Heimildir'} tabname="baekur">
							<p className="mb-3">Þetta erindi má finna í eftirfarandi heimildum.</p>

							<div className="mt-2 mb-3 row">
								{
									data.pages && data.pages.map((page) => <div className="col-6">
										{
											page.page && page.page.files && page.page.files.map((file) => <ImageDisplay src={config.mediaUrl+file.path} />)
										}
										<table className="table metadata-table">
											<tr><td>
												{
													((book) => {
														return <Link to={helpers.routerUrls['baekur']+book.id+(page.page && page.page.id ? '/myndir?syna='+page.page.id+'&erindi='+data.id+'&titill_erindis='+data.first_line : '')}>
															{(book.number || '')+(book.name ? (book.name && book.number ? ' ('+book.name+')' : book.name) : '')}
														</Link>
													})(page.book || page.page.book)
												}
												{
													showPageInfo(page)
												}
												{
													page.source_info && <p> <i dangerouslySetInnerHTML={{__html: page.source_info}} /></p>
												}
												{
													data.pages.length > 1 && page.contents_variant && <div className="mt-4">
														<label>Tibrigði</label><br/>
														<TextDisplay text={page.contents_variant} />
													</div>
												}
											</td></tr>
										</table>
									</div>)
								}
							</div>
						</div>
					}

					{
						otherFiles && otherFiles.length > 0 &&
						<MediaList tabtitle={'Tengdar skrár'}
							tabname="skrar"
							data={otherFiles}>
							<p className="mb-3"><small>Tengdar skrár.</small></p>
						</MediaList>
					}

				</TabContainer>

				{
					data.modification_date &&
					<p className="mt-4 small">Síðast breytt {helpers.formatDate(data.modification_date, false, true)}</p>
				}

			</div>

	)
}

export default StanzaView;
